// This file configures the initialization of Sentry on the client.
// The added config here will be used whenever a users loads a page in their browser.
// https://docs.sentry.io/platforms/javascript/guides/nextjs/

import * as Sentry from '@sentry/nextjs';
import { SENTRY_DSN } from './constants';
import { isSentryEnabled } from './services/sentry';

Sentry.init({
	dsn: SENTRY_DSN,

	// Add optional integrations for additional features
	integrations: [Sentry.replayIntegration()],

	// Define how likely traces are sampled. Adjust this value in production, or use tracesSampler for greater control.
	tracesSampleRate: 1,

	// Define how likely Replay events are sampled.
	// This sets the sample rate to be 10%. You may want this to be 100% while
	// in development and sample at a lower rate in production
	replaysSessionSampleRate: 1,

	// Define how likely Replay events are sampled when an error occurs.
	replaysOnErrorSampleRate: 1,

	profilesSampleRate: 1,
	debug: process.env.NODE_ENV !== 'production',
	environment: process.env.ENVIRONMENT_NAME,
	beforeSend(event) {
		if (!isSentryEnabled()) {
			// return null to discard the event
			return null;
		}
		// send event when enabled
		return event;
	},
});

export const onRouterTransitionStart = Sentry.captureRouterTransitionStart;
